/**
 * `?lang=fr` / `?lang=en` on any app URL forces the language, ahead of the
 * stored choice and the browser's. An incognito window has neither, so this is
 * the only way to open the web app in French there without going through
 * Settings. The detector caches what it returns, so the choice outlives the
 * first route change (which drops the query string).
 *
 * Returns null for a missing or unsupported value; `fr-CA` counts as `fr`.
 */
export function languageFromSearch(search: string | null | undefined): 'en' | 'fr' | null {
  if (!search) return null;
  const value = new URLSearchParams(search).get('lang')?.trim().toLowerCase();
  if (!value) return null;
  if (value === 'fr' || value.startsWith('fr-') || value.startsWith('fr_')) return 'fr';
  if (value === 'en' || value.startsWith('en-') || value.startsWith('en_')) return 'en';
  return null;
}

/** The forced language of the current page, on web only. */
export function languageFromCurrentUrl(): 'en' | 'fr' | null {
  if (typeof window === 'undefined') return null;
  const search = window.location?.search;
  return typeof search === 'string' ? languageFromSearch(search) : null;
}
